import React from "react";

const PaidBlog = () => {
  return <div>PaidBlog</div>;
};

export default PaidBlog;
